












































































import { Component, Prop } from 'vue-property-decorator';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/PreparacionEquipos/FiltrosBusqueda.vue';
import ModalCrear from '@/pantallas/Conecta/PreparacionEquipos/ModalCrear.vue';
import ModalAsignacion from '@/pantallas/Conecta/PreparacionEquipos/ModalAsignacion.vue';

import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { fetchMS } from '@/pantallas/Conecta/PreparacionEquipos/fetchMS';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import config from '@/config/index';
import { Validator } from 'vee-validate';
import ValidaRut from '@/config/validaRut';
import { utils, writeFileXLSX } from 'xlsx';

@Component({
  components: {
    MantenedorGrid,
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    ModalCrear,
    ModalAsignacion,
    FormFieldsContainer,
  },
})
export default class AsignacionNoSeriado extends ComponenteBase {
  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades = Funcionalidades.SolicitudStock;

  @Prop({
    required: true,
    default: { asignumero: '', estado: '', asigdeta_finalizado: '' },
  })
  regSeleccionado: any;

  readonly loadingService = new LoadingService();

  pagina: number = 1;
  hashpaginacion: string = '';
  rowcount: number = 0;
  total_registros: number = 0;
  cant_regs_pag: number = 50;
  filtrobusquedagrilla: string = '';
  listaReq: any[] = [];
  listaEquipos: any[] = [];
  id_editar: string = '';

  columnApi: any = null;
  gridEvent: any = null;
  columnApiResumen: any = null;
  gridEventResumen: any = null;
  serverSide: any = null;
  gridApi: GridApi = null;
  gridApiResumen: GridApi = null;
  showReporteGenerado: boolean = false;
  texto_reporte: string = '';
  showModalNew: boolean = false;
  showModalAsignacion: boolean = false;
  showForm: boolean = false;
  deshabilitar: boolean = false;

  vr: ValidaRut = new ValidaRut();
  anio: any = '';
  dictionaryFormErrors: any = {};
  evt: any;

  loading: boolean = false;

  registros: any = null;
  registrosResumen: any = null;

  readonly gridOptionsResumen: GridOptions = {
    columnDefs: [
      {
        headerName: 'Equipo',
        field: 'equipo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 250,
      },
      {
        headerName: 'Total',
        field: 'total',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
    ],
    pagination: true,
    paginationPageSize: this.cant_regs_pag,
    cacheBlockSize: this.cant_regs_pag,
    onGridReady: this.handleGridReadyResumen,
    onModelUpdated: this.onModelUpdatedResumen,

    overlayNoRowsTemplate: 'No hay filas para mostrar',
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Equipo',
        field: 'equipo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Serie',
        field: 'serie',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Técnico',
        field: 'tecnico',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Región',
        field: 'region',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Ciudad',
        field: 'ciudad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
      },
      {
        headerName: 'Estatus',
        field: 'estatus',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Stock',
        field: 'stock',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'CAS-NDV Asignado',
        field: 'cas_ndv_asignado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Observación',
        field: 'observacion',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'Salida',
        field: 'salida',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'RUT',
        field: 'rut',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
      {
        headerName: 'OK',
        field: 'ok',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
      },
    ],
    pagination: true,
    paginationPageSize: this.cant_regs_pag,
    cacheBlockSize: this.cant_regs_pag,
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,

    overlayNoRowsTemplate: 'No hay filas para mostrar',
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };

  async get_detalle_archivo_stock_resumen() {
    let self = this;
    let body: any = {};
    body.asignumero = self.regSeleccionado.asignumero;
    fetchMS(body, 'get_detalle_archivo_stock_resumen')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '2') {
          self.gridApiResumen.setRowData([]);
          self.gridApiResumen.setDomLayout('autoHeight');
          self.gridApiResumen.showNoRowsOverlay();
          return;
        }
        if (response.data.CODIGO_RESPUESTA == '1') {
          if (response.data.LISTA.length === 0) {
            self.gridApiResumen.setRowData([]);
            self.gridApiResumen.setDomLayout('autoHeight');
          } else {
            self.registrosResumen = response.data.LISTA;
            self.$emit('updateValueEvidenciaResumen', self.registrosResumen);
            self.gridApiResumen.setRowData(response.data.LISTA);
            this.gridApiResumen.setDomLayout('autoHeight');
          }
        } else {
          self.gridApiResumen.setRowData([]);
        }
      })
      .catch((error: any) => {
        console.log(error);
        self.gridApiResumen.setRowData([]);
        self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
          timeout: 3000,
        });
      })
      .finally(() => {
        self.loadingService.hideLoading('grillaNoSeriado');
      });
  }

  async handleGridReadyResumen(event: GridReadyEvent) {
    this.gridApiResumen = event.api;
    this.columnApiResumen = event.columnApi;
    this.gridEventResumen = event;
    let self = this;
    this.get_detalle_archivo_stock_resumen();
  }

  async get_detalle_archivo_stock() {
    let self = this;
    let body: any = {};
    body.asignumero = self.regSeleccionado.asignumero;
    fetchMS(body, 'get_detalle_archivo_stock')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '2') {
          self.gridApi.setRowData([]);
          self.gridApi.setDomLayout('autoHeight');
          self.gridApi.showNoRowsOverlay();
          return;
        }
        if (response.data.CODIGO_RESPUESTA == '1') {
          if (response.data.LISTA.length === 0) {
            self.gridApi.setRowData([]);
            self.gridApi.setDomLayout('autoHeight');
          } else {
            self.$emit('updateValueEvidencia', response.data.LISTA);
            self.registros = response.data.LISTA;
            self.gridApi.setRowData(response.data.LISTA);
            this.gridApi.setDomLayout('autoHeight');
          }
        } else {
          self.gridApi.setRowData([]);
        }
      })
      .catch((error: any) => {
        console.log(error);
        self.gridApi.setRowData([]);
        self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
          timeout: 3000,
        });
      })
      .finally(() => {
        self.loadingService.hideLoading('grillaNoSeriado');
      });
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    let self = this;
    this.get_detalle_archivo_stock();

    /*this.gridApi = event.api;
    //this.gridApi.rowModel.rowsToDisplay = this.rowcount;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.serverSide = {
      getRows(event: any): void {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.pagina = event.request.startRow / self.cant_regs_pag + 1;
        let body: any = {};
        body.asignumero = self.regSeleccionado.asignumero;
        self.loadingService.showLoading(undefined, 'grillaNoSeriado');

        fetchMS(body, 'get_detalle_archivo_stock')
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '2') {
              self.gridApi.setRowData([]);
              self.gridApi.setDomLayout('autoHeight');
              self.gridApi.showNoRowsOverlay();
              return;
            }
            if (response.data.CODIGO_RESPUESTA == '1') {
              if (response.data.data.LISTA.length === 0) {
                self.gridApi.setRowData([]);
                self.gridApi.showNoRowsOverlay();
              } else {
                self.gridApi.setRowData(response.data.data.LISTA);      
                self.gridApi.hideOverlay();
                self.autoSizeAll(true);
              }
            } else {
              event.successCallback([{}], 0);
            }
          })
          .catch((error: any) => {
            event.successCallback([{}], 0);
            self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
              timeout: 3000,
            });
          })
          .finally(() => {
            self.gridApi.setDomLayout('autoHeight');
            self.loadingService.hideLoading('grillaNoSeriado');
          });
      },
    };
    this.gridApi.setServerSideDatasource(this.serverSide);
    this.gridApi.setDomLayout('autoHeight');
    */
  }
  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        ano: {
          required: () => config.errorMensajes.textoRequerido,
          numeric: config.errorMensajes.soloNumeros,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  handleCierreModalCrear() {
    this.showModalNew = false;
  }
  handleCierreModalAsignacion() {
    this.showModalAsignacion = false;
  }

  filtros2body() {}

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  id_usuario: any;
  respuesta: any;
  handleVolverClick() {}

  //Busca dentro del resultado de la grilla
  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  }

  fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };
  accionEliminar: PermisoAccion = {
    accionCodigo: 5,
    visible: false,
  };
  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionEliminar,
    this.accionEditar,
    this.accionCrear,
  ];

  handleCierreModalVerDetalle() {}

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  actions() {}

  constructor() {
    super();
    this.actions();
  }

  validateState() {
    if (
      (this.regSeleccionado != null &&
        ['Finalizado', 'Anulado'].includes(this.regSeleccionado.estado)) ||
      this.regSeleccionado.asigdeta_finalizado === 't'
    ) {
      this.deshabilitar = true;
    }
  }

  async mounted() {
    this.copy_scroll();
    try {
      await Promise.all([this.validateState(), this.initialize()]);
    } catch (err) {
      console.error('Error: ', err);
    }
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    //this.gridApi.setServerSideDatasource(this.serverSide);
  }

  onModelUpdatedResumen() {
    if (!this.gridApiResumen) {
      return;
    }
    //this.gridApiResumen.setServerSideDatasource(this.serverSide);
  }

  scrollcopiado: boolean = false;
  copy_scroll() {
    let copyscroll = setInterval(() => {
      const headers = document.querySelectorAll<HTMLElement>(
        '.asignacionNoSeriado .scroll .ag-root-wrapper-body .ag-body-horizontal-scroll'
      );
      if (headers.length > 1) {
        headers[0].remove();
      }
      if (headers.length === 1) {
        const clonedHeader = headers[0].cloneNode(true) as HTMLElement;
        clonedHeader.classList.add('sticky-scroll'); // Agregar la clase para fijar el elemento al hacer scroll
        const rootWrapper = document.querySelector<HTMLElement>(
          '.asignacionNoSeriado .scroll .ag-root-wrapper-body .ag-root.ag-unselectable.ag-layout-auto-height'
        );
        if (rootWrapper === null) {
          return;
        }
        rootWrapper.prepend(clonedHeader);

        // Sincronizar el scroll horizontal entre el header clonado y el original
        const scrollViewports = document.querySelectorAll<HTMLElement>(
          '.asignacionNoSeriado .scroll .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
        );
        scrollViewports[0].addEventListener('scroll', function() {
          scrollViewports[1].scrollLeft = scrollViewports[0].scrollLeft;
        });
        scrollViewports[1].addEventListener('scroll', function() {
          scrollViewports[0].scrollLeft = scrollViewports[1].scrollLeft;
        });
      }
      // Sincronizar los espaciadores
      const rightSpacers = document.querySelectorAll<HTMLElement>(
        '.asignacionNoSeriado .scroll .ag-root-wrapper-body .ag-horizontal-right-spacer'
      );
      rightSpacers[0].style.width = rightSpacers[1].style.width;
      rightSpacers[0].style.minWidth = rightSpacers[1].style.minWidth;
      rightSpacers[0].style.maxWidth = rightSpacers[1].style.maxWidth;

      const scrollContainer = document.querySelectorAll<HTMLElement>(
        '.asignacionNoSeriado .scroll .ag-root-wrapper-body .ag-body-horizontal-scroll-container'
      );
      scrollContainer[0].style.width = scrollContainer[1].style.width;
      scrollContainer[0].style.minWidth = scrollContainer[1].style.minWidth;
      scrollContainer[0].style.maxWidth = scrollContainer[1].style.maxWidth;

      this.scrollcopiado = true;
      clearInterval(copyscroll);
    }, 2000);
  }
  descargar() {
    let asignumero = this.registros[0].asignumero;
    let informacionOrdenada = this.registros.map((v: any) => {
      return {
        Equipo: v.equipo,
        Serie: v.serie,
        Plataforma: v.plataforma,
        Técnico: v.tecnico,
        Región: v.region,
        Ciudad: v.ciudad,
        Estatus: v.estatus,
        Stock: v.stock,
        'CAS-NDV Asignado': v.cas_ndv_asignado,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'evidencia_stock_' + asignumero);
    writeFileXLSX(wb, 'evidencia_stock_' + asignumero + '.xlsx');
    this.$snotify.success('Excel Exportado Con Éxito', 3000);
  }
  descargarResumen() {
    let informacionOrdenada = this.registrosResumen.map((v: any) => {
      return {
        Equipo: v.equipo,
        Total: v.total,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(
      wb,
      ws,
      'evidencia_stock_resumen' + this.regSeleccionado.asignumero
    );
    writeFileXLSX(
      wb,
      'evidencia_stock_resumen' + this.regSeleccionado.asignumero + '.xlsx'
    );
    this.$snotify.success('Excel Exportado Con Éxito', 3000);
  }
}
